import * as React from 'react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';

export class PortalHeaderLogo extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    return (
      <a href="/" title="Zur Startseite" style={{ display: 'flex', alignItems: 'center' }}>
        <img alt="Schlaukopf Logo" src="/images/schlaukopf_neu.svg" style={{ width: 40, height: 40, marginRight: 12 }} />
        <span>
          <span style={{ color: '#EEE', fontSize: 22, textShadow: '3px 5px 10px #000' }}>Schlaukopf</span>
          <span style={{ color: '#428bca' }}>.de </span>
        </span>
      </a>
    );
  }
}
